import { Absent_getInstance17o8jlyfouexf as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.h6r_1 = partyId;
        this.i6r_1 = name;
        this.j6r_1 = email;
        this.k6r_1 = pairingRule;
        this.l6r_1 = badgesEnabled;
        this.m6r_1 = defaultBadgeName;
        this.n6r_1 = alternateBadgeName;
        this.o6r_1 = callSignsEnabled;
        this.p6r_1 = animationsEnabled;
        this.q6r_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.h6r_1.toString() + ', name=' + toString(this.i6r_1) + ', email=' + toString(this.j6r_1) + ', pairingRule=' + toString(this.k6r_1) + ', badgesEnabled=' + toString(this.l6r_1) + ', defaultBadgeName=' + toString(this.m6r_1) + ', alternateBadgeName=' + toString(this.n6r_1) + ', callSignsEnabled=' + toString(this.o6r_1) + ', animationsEnabled=' + toString(this.p6r_1) + ', animationSpeed=' + toString(this.q6r_1) + ')';
      }
      hashCode() {
        var result = this.h6r_1.hashCode();
        result = imul(result, 31) + hashCode(this.i6r_1) | 0;
        result = imul(result, 31) + hashCode(this.j6r_1) | 0;
        result = imul(result, 31) + hashCode(this.k6r_1) | 0;
        result = imul(result, 31) + hashCode(this.l6r_1) | 0;
        result = imul(result, 31) + hashCode(this.m6r_1) | 0;
        result = imul(result, 31) + hashCode(this.n6r_1) | 0;
        result = imul(result, 31) + hashCode(this.o6r_1) | 0;
        result = imul(result, 31) + hashCode(this.p6r_1) | 0;
        result = imul(result, 31) + hashCode(this.q6r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.h6r_1.equals(other.h6r_1))
          return false;
        if (!equals(this.i6r_1, other.i6r_1))
          return false;
        if (!equals(this.j6r_1, other.j6r_1))
          return false;
        if (!equals(this.k6r_1, other.k6r_1))
          return false;
        if (!equals(this.l6r_1, other.l6r_1))
          return false;
        if (!equals(this.m6r_1, other.m6r_1))
          return false;
        if (!equals(this.n6r_1, other.n6r_1))
          return false;
        if (!equals(this.o6r_1, other.o6r_1))
          return false;
        if (!equals(this.p6r_1, other.p6r_1))
          return false;
        if (!equals(this.q6r_1, other.q6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
